/**
 * Cleaning-readiness reason codes — MUST MATCH the backend.
 *
 * Source of truth: `be/services/cleaningReadiness/engine.js` → `REASON`.
 *
 * Why this file exists: the cleaning engine emits a machine `reasonCode` alongside its
 * Arabic `displayText`, and I18N_STRATEGY is explicit that the CODE is the contract —
 * meaning is never inferred from message text, which is display copy that can be
 * reworded freely. Mirroring the codes here is the same import boundary
 * `utils/arrivalErrorCodes.js` and `config/arrivalLabels.js` establish for their own
 * surfaces, and it is what lets the column render in the operator's own language
 * instead of whatever language the server happened to write in.
 *
 * The lock and message columns still render server prose — they predate the contract
 * and decoupling them needs backend changes. Cleaning arrived with the contract, so it
 * is wired up properly from day one rather than re-buried.
 *
 * `displayText` from the server remains the fallback for any code added on the backend
 * before this file learns about it: an unrecognised code shows the server's own words
 * rather than a blank cell or a raw key path.
 */
export const CLEANING_REASON_CODES = {
  DONE: 'CLEANING_DONE',
  ON_TRACK: 'CLEANING_ON_TRACK',
  DUE_SOON: 'CLEANING_DUE_SOON',
  IN_PROGRESS: 'CLEANING_IN_PROGRESS',
  OVERDUE: 'CLEANING_OVERDUE',
  WINDOW_NEGATIVE: 'CLEANING_WINDOW_NEGATIVE',
  WINDOW_TIGHT: 'CLEANING_WINDOW_TIGHT',
  WINDOW_UNKNOWN: 'CLEANING_WINDOW_UNKNOWN',
  NO_TASK: 'CLEANING_NO_TASK',
  UNKNOWN_ARRIVAL: 'CLEANING_UNKNOWN_ARRIVAL',
  ASSESS_FAILED: 'CLEANING_ASSESS_FAILED'
};

/** Locale key for a reason code, or null when the code is unknown to this build. */
export const cleaningReasonKey = (code) =>
  (code && Object.values(CLEANING_REASON_CODES).includes(code))
    ? `arrivalReadiness.cleaningReason.${code}`
    : null;
